import { Landing } from '../components/Landing';

import type { NextPage } from 'next';

const Home: NextPage = () => {
  return <Landing />;
};

export default Home;
